import React, {Component} from "react";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import CoreService from "../../service/CoreService";
import MocksConfigService from "../../service/MocksConfigService";
import {Link} from "react-router";
import MockDetailPanel from "./MockDetailPanel";
import MocksStatusService from "../../service/MocksStatusService";
import FancyFileUpload from "../common/FancyFileUpload";
import './Mock.css';
import {FormattedDate, FormattedTime} from "react-intl";
import {defaultTenantId} from "../../service/TenantService";

const INITIAL_STATUS = {
    status: 'LOADING'
};

class Mock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: INITIAL_STATUS,
            refreshHandle: null,
            files: null,
            events: null,
            mockId: props.params.mockId || defaultTenantId,
        };

        this.fetchStatus = this.fetchStatus.bind(this);
        this.listFiles = this.listFiles.bind(this);
        this.fetchEvents = this.fetchEvents.bind(this);
        this.uploadSpecification = this.uploadSpecification.bind(this);
    }

    fetchStatus() {
        const self = this;

        MocksStatusService.fetchMocksStatus(this.state.mockId, (mocksStatus) => {
            if (mocksStatus) {
                self.setState({status: mocksStatus});
                if (mocksStatus.status === 'UPDATING') {
                    self.deferRefreshStatus();
                }
            } else {
                CoreService.showPassiveError("Sorry, we can't fetch the status of your mocks right now.");
            }
        });
    }

    listFiles() {
        const self = this;

        MocksConfigService.fetchFiles(this.state.mockId, (files) => {
            const fileRows = [];

            files.forEach((fileName) => {
                fileRows.push(
                    <tr key={fileName}>
                        <td>{fileName}</td>
                        <td><a href="#" onClick={(e) => self.deleteFile(e, fileName)}><i className="small icon icon-trash m-r-xs"/>Delete</a></td>
                    </tr>
                )
            });

            self.setState({files: fileRows});
        });
    }

    fetchEvents() {
        const self = this;

        MocksConfigService.fetchEvents(this.state.mockId, (events) => {
            const eventRows = [];
            let rowId = 0;
            events.forEach((event) => {
                eventRows.push(
                    <tr key={rowId++}>
                        <td><FormattedDate
                            value={event.occurred}
                            day="numeric"
                            month="numeric"
                            year="numeric"
                        />&nbsp;<FormattedTime
                            value={event.occurred}
                            hour12={false}
                        /></td>
                        <td>{event.description}</td>
                    </tr>
                )
            });

            self.setState({events: eventRows});
        });
    }

    /**
     * Delete the file with the given name.
     *
     * @param e {Event}
     * @param fileName {String}
     */
    deleteFile(e, fileName) {
        e.preventDefault();
        const self = this;

        MocksConfigService.deleteFile(this.state.mockId, fileName, () => {
            // notify user
            CoreService.showPassiveInfo('Deleted mock configuration file.');

            // refresh UI
            self.refreshUi();
        });
    }

    uploadSpecification(files) {
        MocksConfigService.uploadSpecification(this.state.mockId, files, () => {
            // notify user
            CoreService.showPassiveInfo('Uploaded mock configuration file.');

            // clear file picker
            this.fileUpload.clear();

            // refresh UI
            this.refreshUi();
        });
    }

    refreshUi = () => {
        this.listFiles();
        this.deferRefreshStatus();
    };

    deferRefreshStatus = () => {
        this.stopAutoRefresh();

        // this is a bit inelegant
        const refreshHandle = window.setTimeout(() => this.fetchStatus(), 2000);
        this.setState({
            refreshHandle: refreshHandle,
        });
    };

    componentDidMount() {
        this.fetchStatus();
        this.fetchEvents();
        this.listFiles();
    }

    componentWillUnmount() {
        this.stopAutoRefresh();
    }

    stopAutoRefresh() {
        if (this.state.refreshHandle !== null) {
            window.clearTimeout(this.state.refreshHandle);
        }
    }

    render() {
        return (
            <div>
                <TopNav tab="mocks"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">API Mock</h1>
                                <h4 className="text-muted">Interactive mocks for OpenAPI, REST and SOAP/WSDL.</h4>
                            </div>
                        </div>

                        <div className="row m-b-sm">
                            <div className="col-lg-12">
                                <p>Upload OpenAPI specification files to create an interactive mock API.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-10 col-md-8 col-lg-8">
                                {/* Mock status/URL */}
                                <MockDetailPanel
                                    mockId={this.state.mockId}
                                    status={this.state.status}
                                    onRefresh={() => this.setState({status: INITIAL_STATUS}, this.fetchStatus)}
                                />

                                {/* File upload */}
                                <div className="panel panel-info">
                                    <div className="panel-heading"><h3 className="panel-title">Mock files</h3></div>
                                    <div className="panel-body">
                                        {this.state.files === null &&
                                            <div className="text-muted">Fetching files...</div>}

                                        {this.state.files && this.state.files.length === 0 &&
                                            <div className="text-muted">You haven't uploaded any files.</div>}

                                        {this.state.files && this.state.files.length > 0 &&
                                            <table className="table table-striped">
                                                <thead>
                                                <tr>
                                                    <th>Filename</th>
                                                    <th>Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.files}
                                                </tbody>
                                            </table>}

                                        <hr/>
                                        <h5>Upload API specification</h5>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <p>Upload a valid OpenAPI 3.0/OpenAPI 2.0 specification or script file.</p>
                                                <FancyFileUpload onUploadClick={this.uploadSpecification}
                                                                 ref={instance => this.fileUpload = instance}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Events */}
                                <div className="panel panel-info">
                                    <div className="panel-heading">
                                        <h3 className="panel-title">Events
                                            <button type="button" className="btn btn-xs btn-default btn-borderless pull-right"
                                                    onClick={this.fetchEvents}><i className="icon icon-cycle m-r-xs"/>Refresh
                                            </button>
                                        </h3>
                                    </div>
                                    <div className="panel-body">
                                        {this.state.events === null &&
                                            <div className="text-muted">Fetching events...</div>}

                                        {this.state.events && this.state.events.length === 0 &&
                                            <div className="text-muted">No events.</div>}

                                        {this.state.events && this.state.events.length > 0 &&
                                            <table className="table table-striped">
                                                <thead>
                                                <tr>
                                                    <th>Occurred</th>
                                                    <th>Description</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.events}
                                                </tbody>
                                            </table>}
                                    </div>
                                </div>

                            </div>

                            {/* Tip */}
                            <div className="col-sm-10 col-md-4">
                                <div className="callout m-t-0 m-b-sm">
                                    <div className="callout-content">
                                        <strong>Need some inspiration?</strong><br/>Learn more about mock specifications and script files.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link to="/docs" className="btn btn-sm btn-info secondary-fixed-width-btn">Learn more</Link>
                                    </div>
                                </div>
                            </div>

                            {/* Logs */}
                            <div className="col-sm-10 col-md-4">
                                <div className="callout m-t-0 m-b-md">
                                    <div className="callout-content">
                                        <strong>Logs</strong><br/>More information can be found in the logs for this mock.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link to="/logs" className="btn btn-sm btn-default secondary-fixed-width-btn">View logs</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Mock;



// WEBPACK FOOTER //
// ./src/modules/views/mocks/Mock.js